


























































import Vue from 'vue'
import FeatureDisabled from '@/components/FeatureDisabled.vue'
import OfficeHours from '@/types/OfficeHours.interface'
import OfficeHoursDay from '@/components/OfficeHoursDay.vue'
import MessagePreviewBubble from '@/components/MessagePreviewBubble.vue'
import Analytics from '@/services/Analytics'
import { timezoneUpdate, validateTimezone } from '@/utility/helpers'
import Tenant from '@/types/Tenant.interface'
export default Vue.extend({
    components: { FeatureDisabled, MessagePreviewBubble, OfficeHoursDay },
    data() {
        return {
            //  Determines if we finished all of our mounting setup
            mounted: false,
            temp: null,
            showPaywall: true,
            toolbar: {
                title: 'Office Hours',
                backButton: true,
                right: [],
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/plugins',
                        tooltip: 'Back',
                        permission: 0
                    }
                ]
            }
        }
    },
    mounted() {
        //  Check that the tenant has a timezone setup
        if (this.officeHoursEnabled) validateTimezone()

        //  Clone officeHours into 'temp'
        this.temp = window._.cloneDeep(this.officeHours)

        //  We finished everything so we are now mounted
        this.mounted = true
    },
    computed: {
        imgStyles(): string {
            //  For extra large screens
            if (this.$vuetify.breakpoint.xlOnly)
                return 'right:40px; top:150px; max-width:650px; position:absolute;'

            //  For large sized screens
            if (this.$vuetify.breakpoint.lgOnly)
                return 'right:40px; top:120px; max-width:560px; position:absolute; z-index:1;'

            //  For small screens
            if (this.$vuetify.breakpoint.smOnly)
                return 'display:flex; margin:0 auto; max-width:40%'

            //  Else, return nothing
            return
        },
        officeHours(): OfficeHours {
            return this.$store.getters.officeHours
        },
        officeHoursEnabled(): boolean {
            return this.$store.getters.getEnabled('office_hour')
        },
        tenant(): Tenant {
            return this.$store.getters.tenant
        }
    },
    methods: {
        editResponseHandler(): void {
            //  Create the app-form props
            const props = {
                model: this.temp,
                inputs: [
                    {
                        type: 'MESSAGE_TEXT_FORM',
                        hideMedia: true,
                        print: false,
                        path: 'response',
                        validate: 'required'
                    }
                ]
            }

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Update Response',
                icon: 'mdi-clock',
                color: 'primary',
                component: 'app-form',
                props: props,
                callback: async (hours: OfficeHours): Promise<void> =>
                    await this.editResponse(hours)
            })
        },
        async editResponse(hours: OfficeHours): Promise<void> {
            //  Send the changes to the API
            const response = await this.$store.dispatch('officeHoursPut', hours)

            //  If the response does NOT exist, do nothing
            if (!response) return

            //  Close the app dialog
            this.$store.dispatch('dialogClose', 'APP')
        },
        popHoursHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Organization Office Hours',
                text: `Organization office hours allow you to send automatic "out of office" messages to contacts based on your set availability. Set the days and hours that you're available and open to receiving inbound text messages.`,
                icon: 'mdi-clock',
                color: 'primary'
            })
        },
        popResponseHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Response Message',
                text: `The "Out of Office" Response Message is an automatic message. When a contact texts your organization during non-open (closed) office hours they will automatically receive this message.`,
                icon: 'mdi-message-reply-text',
                color: 'primary'
            })
        },
        timezoneUpdate(): void {
            timezoneUpdate()
        }
    },
    watch: {
        officeHours: {
            deep: true,
            handler(val: OfficeHours): void {
                if (val) this.temp = window._.cloneDeep(val)
            }
        },
        officeHoursEnabled(bool: boolean): void {
            //  If false, do nothing
            if (!bool) return

            //  Else, validate the timezone
            validateTimezone()
        },
        temp: {
            deep: true,
            handler(val: OfficeHours): void {
                //  Compare the new officeHours value with our temp
                const isEqual = window._.isEqual(val, this.officeHours)

                //  If the two objects are identical, do nothing
                if (isEqual) return

                //  Send the changes to the API
                this.$store.dispatch('officeHoursPut', val)
            }
        }
    }
})
